import Cookies from "js-cookie";

/**
 * Cookie options type
 */
type CookieOptions = {
  expires?: Date | number;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: "strict" | "lax" | "none";
};

/**
 * Sets a cookie with the given name and value
 * @param cookieName - The name of the cookie to set
 * @param value - The value to store in the cookie
 * @param options - Optional cookie configuration options
 * @returns The string that was set or undefined if the cookie couldn't be set
 */
export const setCookie = (
  cookieName: string,
  value: string,
  options?: CookieOptions
): string | undefined => {
  const defaultOptions: CookieOptions = {
    expires: new Date(new Date().getTime() + 15 * 60 * 1000), // 15 minutes from now
    secure: true,
    sameSite: "strict",
    path: "/"
  };

  return Cookies.set(cookieName, value, { ...defaultOptions, ...options });
};

/**
 * Gets the value of a cookie by name
 * @param cookieName - The name of the cookie to retrieve
 * @returns The cookie value if found, undefined otherwise
 */
export const getCookie = (cookieName: string): string | undefined => {
  return Cookies.get(cookieName);
};

/**
 * Removes a cookie by name
 * @param cookieName - The name of the cookie to remove
 * @returns void
 */
export const removeCookie = (cookieName: string): void => {
  Cookies.remove(cookieName);
};
